import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from '../../theme/GlobalTheme';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const LoadingContainer = styled.div`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  padding: ${theme.spacing.lg};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  box-sizing: border-box;
`;

const LoadingCard = styled.div`
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.card};
  padding: ${theme.spacing.xl};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 4px solid ${theme.colors.tertiary};
  border-top: 4px solid ${theme.colors.primary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin-bottom: ${theme.spacing.lg};
`;

const LoadingText = styled.h2`
  font-size: ${theme.typography.fontSize.h3};
  color: ${theme.colors.primary};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeight.bold};
  margin: 0 0 ${theme.spacing.sm} 0;
  text-align: center;
`;

const LoadingSubtext = styled.p`
  font-size: ${theme.typography.fontSize.body};
  color: ${theme.colors.text};
  font-family: ${theme.typography.fontFamily};
  margin: 0;
  text-align: center;
  animation: ${pulse} 2s ease-in-out infinite;
`;

const LoadingDots = styled.span`
  &::after {
    content: '...';
    animation: ${pulse} 1.5s ease-in-out infinite;
  }
`;

const LoadingScreen = ({ message = 'Generating Report', submessage = 'This may take a few moments' }) => {
  return (
    <LoadingContainer>
      <LoadingCard>
        <Spinner />
        <LoadingText>{message}</LoadingText>
        <LoadingSubtext>
          {submessage}
          <LoadingDots />
        </LoadingSubtext>
      </LoadingCard>
    </LoadingContainer>
  );
};

export default LoadingScreen;
